export const IoTCoreAdminSystemInfo = {
  URL: import.meta.env.VITE_ADMIN_URL,
  systemKey: import.meta.env.VITE_ADMIN_SYSTEM_KEY,
  systemSecret: import.meta.env.VITE_ADMIN_SYSTEM_SECRET,
  regionList: import.meta.env.VITE_ADMIN_REGION_LIST.split(','),
};
